import { render } from "./VetHome.vue?vue&type=template&id=3e489ed0"
import script from "./VetHome.vue?vue&type=script&lang=js"
export * from "./VetHome.vue?vue&type=script&lang=js"

import "./VetHome.vue?vue&type=style&index=0&id=3e489ed0&lang=css"

import exportComponent from "E:\\ph_ready_one\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__